import { StoreService } from '@se-po/se-household-setup-data-access-store'
import {
  PasswordFormSubmitter
} from '@se-po/se-household-setup-feature-create-password'
import { BehaviorSubject } from 'rxjs'

export class DocsPasswordSubmitter implements PasswordFormSubmitter {
  public submitting = new BehaviorSubject<boolean>(false)
  public unknownError = false
  public submit(store: StoreService): void {
    console.log('submitting with params', store)
  }
  public redirect(url: string): void {
    console.log('redirecting to', url)
  }
  public validateAccount(store: StoreService): void {
    console.log('validateAccount')
  }
  public validateAndSubmit(store: StoreService, captchaRef?: any): void {
    console.log('validateAndSubmit will initiate captcha if necessary')
  }
}
